import { BaseApiService } from '@/services/base-service';
import { AlfaApiLoanApplications } from '@/modules/alfa-api-loan-applications/types';
import {
  RequestPagination, ResourceResponse, Response,
} from '@/types';

export class AlfaApiLoanApplicationService extends BaseApiService {
  private readonly base_path = 'alfa-api-loan-applications';

  async get(
    organizationIds: number[],
    statusIds: number[],
    orderIds: number[] = [],
    createdDates: string[] = [],
    orderDates: string[] = [],
    pagination: RequestPagination,
  ) {
    const params: Record<string, unknown> = {};

    params.organization_ids = organizationIds;
    params.status_ids = statusIds;
    params.order_ids = orderIds;

    if (createdDates.length === 2) {
      const [
        createdAfter, createdBefore,
      ] = createdDates;

      params.created_after = createdAfter;
      params.created_before = createdBefore;
    }

    if (orderDates.length === 2) {
      const [
        orderAfter, orderBefore,
      ] = orderDates;

      params.order_after = orderAfter;
      params.order_before = orderBefore;
    }

    params.limit = pagination.limit;
    params.page = pagination.page;
    params.sort = pagination.sort;
    params.sort_type = pagination.sort_type;

    const response = await this.http_client.get<ResourceResponse<AlfaApiLoanApplications.AlfaApiLoanApplication[]>>(this.base_path, {
      params,
    });

    return response.data;
  }

  async getById(id: number) {
    const url = `${this.base_path}/${id}`;
    const response = await this.http_client.get<Response<AlfaApiLoanApplications.AlfaApiLoanApplication>>(url);

    return response.data.data;
  }

  async store(orderId: number | string) {
    const response = await this.http_client.post<Response<AlfaApiLoanApplications.AlfaApiLoanApplication>>(this.base_path, {
      order_id: orderId,
    });

    return response.data.data;
  }
}
